import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LangFormatPipe } from './pipes/lang-format.pipe';
import { DateTime } from 'luxon';

export class crossMsg {
  cmd: string;
  msg: any | null;
  constructor(c: string, v: any) {
    this.cmd = c;
    this.msg = v;
  }
}

@Injectable({
  providedIn: 'root'
})
export class CrossService {
  
  langPipe: LangFormatPipe = new LangFormatPipe();

  constructor() { 
  }

  public iniziali(nickname: string) {
    let nick = '';
      if (nickname) {
        const s = nickname.split(' ');
        if (s.length >= 2) {
          if (s[0].length >= 1)
            nick += s[0][0].toUpperCase();
          else 
            nick += 'A';
          if (s[1].length >= 1)
            nick += s[1][0].toUpperCase();
          else
            nick += 'A';
        } else {
          if (s[0].length >= 1)
            nick += s[0][0].toUpperCase();
          else 
            nick += 'A';
          if (s[0].length >= 2)
            nick += s[0][1].toUpperCase();
          else 
            nick += 'A';
        }
      } else {
        nick = 'AA';
      }
    return nick;
  }

  public getOre(tempo: number): number {
    return Math.floor(tempo);
  }

  public getMinuti(tempo: number): number {
    const minuti = tempo - Math.floor(tempo);
    switch (minuti) {
      case 0:
        return 0;
        break;
      case 0.25:
        return 15;
        break;
      case 0.50:
        return 30;
        break;
      case 0.75:
        return 45;
        break;
      default:
        return 0;
        break;
    }
  }

  getLangString(field: string, lang: string) {
    return this.langPipe.transform(field, lang);
  }

  getInternalParams(myParams: string) {
    if (!myParams)
      return {};

    let containerParams = new Map<string, string>();
    if (myParams.indexOf('&') < 0) {
      let paramName = myParams.split('=')[0];
      let paramValue = myParams.split('=')[1];
      containerParams.set(paramName, paramValue);
    } else {
      let params = myParams.split('&');
      params.forEach(param => {
        let paramName = param.split('=')[0];
        let paramValue = param.split('=')[1];
        containerParams.set(paramName, paramValue);
      });
    }

    return Object.fromEntries(containerParams);    
  }

  public replaceAll(str: string, search: string, replacement: string) {
    return str.split(search).join(replacement);
  }

  public formatLocaleDate(dt: DateTime, currLang: string) {
    if (currLang.toUpperCase() === 'EN') {
      return this.to2digit(dt.month) + '/' + this.to2digit(dt.day) + '/' + dt.year;
    } else {
      return this.to2digit(dt.day) + '/' + this.to2digit(dt.month) + '/' + dt.year;
    }
  }

  public to2digit(n: number) {
    return ('00' + n).slice(-2);
  }


}
